import current from './current';

const project = [
  {
    path: '/project/current',
    component: () => import('@/page/project/Current.vue'),
    children: [...current],
    meta: {
      name: '프로젝트',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  },
];

export default project;
